import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export interface StartSyncResponse {
  jobId: string;
  filesFound: number;
}

interface StartSyncParams {
  matterId: string;
  workspaceId: number;
  includeExisting?: boolean;
}

const useStartRelativitySync = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const startSync = async ({
    matterId,
    workspaceId,
    includeExisting = false,
  }: StartSyncParams): Promise<StartSyncResponse> => {
    const url = `${APIBaseChronos}/api/relativity/sync?matterId=${matterId}&workspaceId=${workspaceId}&includeExisting=${includeExisting}`;
    const response = await fetch(url, getFetchConfig({ method: FetchMethod.POST }));

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Failed to start sync: ${response.status} ${response.statusText}`);
    }

    return response.json();
  };

  return useMutation(startSync);
};

export default useStartRelativitySync;
